// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"662de04e","214":"8880c9bb","241":"0bd6480a","453":"7ee4257d","535":"c940c844","561":"0a778a77","901":"33fa2c31"}[chunkId] + ".chunk.js";
};